import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "how-section__description" }
const _hoisted_2 = { class: "items-wrap" }
const _hoisted_3 = { class: "item__info-box" }
const _hoisted_4 = { class: "item__description" }

import ContentContainer from '@/layout/ContentContainer.vue'
import BaseButton from '@/components/Base/BaseButton.vue';
import {useI18n} from 'vue-i18n'
import {useStore} from "vuex";
import {ComponentInstance, computed, ref} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HowItWorks',
  setup(__props) {

const {t} = useI18n()
const store = useStore()

const langCode = computed(() => {
  return useI18n().locale
})

const content = computed(() => {
  return store.state.pageContent
})

const scrollToForm = () => {
  document?.querySelector('.form')?.scrollIntoView({behavior: "smooth"})
}



return (_ctx: any,_cache: any) => {
  return (!content.value['how_it_works_section_is_hidden_' + langCode.value.value])
    ? (_openBlock(), _createBlock(ContentContainer, {
        key: 0,
        class: "how-section"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", {
            class: "how-section__title",
            style: _normalizeStyle([content.value['color'] ? {color: content.value['color']} : ''])
          }, _toDisplayString(content.value['how_it_works_section_title_' + langCode.value.value] ?? ''), 5),
          _createElementVNode("p", _hoisted_1, _toDisplayString(content.value['how_it_works_section_description_' + langCode.value.value] ?? ''), 1),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value.how_it_works_section_steps, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([`item--${index}`, "item"])
              }, [
                _createElementVNode("div", {
                  class: "item__number",
                  style: _normalizeStyle([content.value['color'] ? {backgroundColor: content.value['color']} : '#253FDC'])
                }, _toDisplayString(index+1), 5),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", {
                    class: "item__title",
                    style: _normalizeStyle([content.value['color'] ? {color: content.value['color']} : ''])
                  }, _toDisplayString(item['title_' + langCode.value.value]), 5),
                  _createElementVNode("div", {
                    class: "item__title__line",
                    style: _normalizeStyle([content.value['color'] ? {backgroundColor: content.value['color']} : '#253FDC'])
                  }, null, 4),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(item['text_' + langCode.value.value]), 1)
                ])
              ], 2))
            }), 128))
          ]),
          _createVNode(BaseButton, {
            class: "how-section__btn",
            value: content.value["how_it_works_section_button_text_" + langCode.value.value] ?? "",
            onHandleClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToForm()))
          }, null, 8, ["value"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})